import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import NoteManage from '../views/NoteManage.vue'
import ItemManage from '../views/ItemManage.vue'
import ItemTypeManage from '../views/ItemTypeManage.vue'
import LogManage from '../views/LogManage.vue'
import SystemSetting from '../views/SystemSetting.vue'
import UserCenter from '../views/UserCenter.vue'
import DataStatistics from '../views/DataStatistics.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/',
    redirect: '/notes'
  },
  {
    path: '/notes',
    name: '记事',
    component: NoteManage
  },
  {
    path: '/items',
    name: '物品',
    component: ItemManage
  },
  {
    path: '/item-types',
    name: '物品分类',
    component: ItemTypeManage
  },
  {
    path: '/logs',
    name: '操作日志',
    component: LogManage
  },
  {
    path: '/system-setting',
    name: '系统设置',
    component: SystemSetting
  },
  {
    path: '/user-center',
    name: '个人中心',
    component: UserCenter,
    meta: { 
      hideInMenu: true  // 不在菜单中显示
    }
  },
  {
    path: '/statistics',
    name: '数据统计',
    component: DataStatistics
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫：未登录跳转登录页
router.beforeEach((to, from, next) => {
  const isLogin = !!store.state.user.token
  if (to.path !== '/login' && !isLogin) {
    next({ path: '/login' })
  } else if (to.path === '/login' && isLogin) {
    // 已登录访问登录页，自动跳转首页
    next({ path: '/accounts' })
  } else {
    next()
  }
})

export default router